import React, { Component } from "react";
import { connect } from "react-redux";
import Rdx from "../../../redux/Rdx";

import AreaProperties from "./AreaProperties";
import HotelArea from "./HotelArea";
import HotelAreaDetails from "./HotelAreaDetails";
import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import OfficePlan from "../../base/OfficePlan";
import Topic from "../../../context/Topic";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../../components/util/component";
import Skeleton from "react-loading-skeleton";

import ListHeader from "../common/ListHeader";

// Styled Components
import { ContentWrapper } from "../../styles/Work/workBar";
import { Panel } from "../../styles/Common/panel";
import { EmptyListMessage } from "../../styles/Common/emptyListMessage";

// calcite-react
import Button from "calcite-react/Button";
import PlusIcon from "calcite-ui-icons-react/PlusIcon";

class HotelsPanel extends Component {
  _mounted = false;
  constructor(props) {
    super(props);
    this.state = component.newState({
      areas: null,
      isExpanded: false
    });
  }

  addClicked = () => {
    const i18n = Context.instance.i18n;
    AreaProperties.showModal({
      caption: i18n.spaceplanner.hotelAreas.addArea,
      areaType: this.getAreaType()
    });
  };

  backClicked = event => {
    // reset the currently selected active item
    const rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTEL_AREA_ID;
    Rdx.setValue(this, rdxActiveAreaKey, null);
    this.setState({isExpanded: false})
  };

  componentDidMount() {
    this._mounted = true;
    this.queryAreas();

    component.own(this, [
      Topic.subscribe(Topic.PlanModified, params => {
        const actions = [OfficePlan.Action_AssignmentsUpdated];
        if (actions && actions.indexOf(params.action) !== -1) {
          this.queryAreas();
        }
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
    this._mounted = false;
  }

  getAreaType = () => {
    return OfficePlan.SpaceAssignmentTypes.hotel;
  };

  getAreaId = areaItem => {
    return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_ID);
  };

  queryAreas = () => {
    const officePlan = OfficePlan.getActive();
    officePlan
      .queryHotelAreas()
      .then(result => {
        if (!this._mounted) return;
        this.setState({ areas: result });
      })
      .catch(ex => {
        console.warn("Error querying hotel areas:");
        console.error(ex);
        if (!this._mounted) return;
        Topic.publishErrorAccessingData();
      });
    return Promise.resolve(true);
  };

  renderHeader = () => {
    const { rdxActiveAreaId } = this.props;
    const i18n = Context.instance.i18n;
    return rdxActiveAreaId ? (
      <ListHeader backClicked={this.backClicked}></ListHeader>
    ) : (
      <ListHeader
        title={i18n.spaceplanner.hotelAreas.caption}
        button={this.renderAddButton()}
      ></ListHeader>
    );
  };
  
  onIsExpanded = (isExpanded) => {
    this.setState(({isExpanded: isExpanded}))
  }

  renderContent = () => {
    const { rdxActiveAreaId } = this.props;
    if (rdxActiveAreaId) {
      const { areas } = this.state;
      if (areas !== null) {
        const foundItem = areas.find(areaItem => {
          return this.getAreaId(areaItem) === rdxActiveAreaId;
        });
        return foundItem ? <HotelAreaDetails areaItem={foundItem} onIsExpanded={this.onIsExpanded}/> : null;
      } else {
        return null;
      }
    } else {
      return this.renderAreas();
    }
  };

  render() {
    //const { rdxActiveAreaId } = this.props;
    return (
      <Panel style={{...(!this.state.isExpanded ? {width: '19.595rem'} : {})}}>
        {this.renderHeader()}
        <ContentWrapper 
          className="i-sp-hotels-panel"
          areas 
          style={{maxHeight: "calc(100vh - 115px)"}}>
            {this.renderContent()}
        </ContentWrapper>
      </Panel>
    );
  }

  renderAddButton = () => {
    const i18n = Context.instance.i18n;
    return (
      <Button
        onClick={this.addClicked}
        icon={<PlusIcon size={16} />}
        iconPosition="before"
      >
        {i18n.general.add}
      </Button>
    );
  };

  renderAreas = () => {
    const { areas } = this.state;

    if (areas !== null && areas.length > 0) {
      const oidField = OfficePlan.getActive().areasTable.table.objectIdField;
      return areas.map(area => {
        return this.renderArea(area,oidField);
      });
    } else if (areas !== null && areas.length === 0) {
      return (
        <EmptyListMessage>
          {Context.instance.i18n.spaceplanner.hotelAreas.noneInList}
        </EmptyListMessage>
      );
    } else {
      return <Skeleton count={10} height={50} />;
    }
  };

  renderArea = (area,oidField) => {
    const id = aiimUtil.getAttributeValue(area.attributes, FieldNames.AREA_ID);
    const oid = aiimUtil.getAttributeValue(area.attributes, oidField);
    return <HotelArea key={id+"_"+oid} areaItem={area} queryAreas={this.queryAreas} />;
  };
}

const mapStateToProps = (state, ownProps) => {
  const rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTEL_AREA_ID;
  return {
    rdxActiveAreaId: Rdx.getValue(state, rdxActiveAreaKey)
  };
};

export default connect(mapStateToProps)(HotelsPanel);
